import React from "react";

// import { Container } from './styles';

const account: React.FC = () => {
  return <div />;
};

export default account;
